/* eslint-disable max-len */
/**
 * Italian translations.
 */
export default {
  ACTION: {
    MESSAGE_DETAILS: 'Dettagli del messaggio',
    OK: 'OK'
  },
  ERROR: {
    ERROR: 'Errore',
    FETCH_DATA: 'Recupera i dati',
    NO_ORDER: 'Impossibile effettuare l\'ordine'
  },
  HEADER: {
    DATE: 'Data',
    MESSAGE: 'Messaggio',
    NAME: 'Nome del cliente',
    ORDER_CODE: 'Codice dell\'ordine',
    ORDER_DATE: 'Data dell\'ordine',
    ORDER_ID: 'Ordine',
    ORDER_VALUE: 'Valore',
    PAYMENT_DATE: 'Data del pagamento',
    PAYMENT_STATE: 'Stato del pagamento',
    PRICE: 'Prezzo',
    VALUE: 'Valore'
  },
  LABEL: {
    COPIED: 'Copiato!',
    EXPORT: 'Esportare',
    GIVEWAY_DATE: 'Data dell\'estrazione:',
    MONTH: 'Mese attuale',
    ORDER_PRIZE_MSG: 'L\'ordine tracciato è stato:',
    PAYED: 'Pagato',
    PRIZE: 'Giveaway',
    RAFFLE: 'Giveaway',
    UNPAYED: 'Non pagato',
    UNTIL: 'until',
    YEAR: 'Anno'
  },
  SENTENCE: {
    NO_ROWS_ORDER_MESSAGES: 'Nessun messaggio',
    NO_ROWS_ORDER_MESSAGES_DESCRIPTION:
      'Nessun messaggio del cliente (per il momento).',
    NO_ROWS_ORDERS: 'Nessun ordine',
    NO_ROWS_ORDERS_DESCRIPTION: 'Nessun ordine (per il momento).'
  },
  SUCCESS: {
    SUCCESS: 'Successo'
  },
  TOOLTIP: {
    DATE: 'Data',
    ORDER_CODE: 'Codice dell\'ordine',
    ORDER_ID: 'Ordine',
    PAYMENT_DATE: 'Data del pagamento',
    PAYMENT_STATE: 'Stato del pagamento',
    PRICE: 'Prezzo',
    VALUE: 'Valore'
  }
};
